import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classNames } from '@ux/component-utilities';

const UX_BUTTON_SET_CLASSNAME = 'ux-button-set';

/**
 * UXCore based ButtonSet.
 *
 * @displayName Button Set
 * @class ButtonSet
 * @public
 */
export default class ButtonSet extends Component {
  constructor() {
    super();
  }

  /**
   * Render the ButtonSet Component.
   *
   * @returns {ReactElement} ButtonSet element.
   * @private
   */
  render() {
    const { className, split, children } = this.props;
    const hostClassNames = classNames(UX_BUTTON_SET_CLASSNAME, className);
    const marginClassNames = classNames(`${UX_BUTTON_SET_CLASSNAME}-margin`, { [`${UX_BUTTON_SET_CLASSNAME}-split`]: split });

    return (
      <div className={ hostClassNames }>
        <div className={ marginClassNames } role='group'>
          { children }
        </div>
      </div>
    );
  }
}

/**
 * Optional properties: split defines if the ButtonSet's
 * children should split to multiple lines or not.
 *
 * @enum {Object} expected types of properties.
 * @public
 */
ButtonSet.propTypes = {
  /** Classes to set on the element */
  className: PropTypes.string,
  /** Defines whether child elements too wide to fit on screen should drop down to the next line*/
  split: PropTypes.bool,
  /** Child elements to be included in the Button Set*/
  children: PropTypes.node
};
